import { PageSkeleton } from "@/components/PageSkeleton";

/**
 * @deprecated Use PageSkeleton component instead
 * Example: <PageSkeleton variant="dashboard" />
 */
export const PageLoader = () => {
  return <PageSkeleton variant="dashboard" />;
};
